// extracted by mini-css-extract-plugin
export default {"overlay":"Jv-z","bodyOpen":"Kv-z","content":"Lv-z","header":"Mv-z","close":"Nv-z","closeNoHeading":"Ov-z"};